import careerListQuery from '../career/listQuery';
import investorRelationsListQuery from '../investorRelation/listQuery';
import accordionQuery from '../modules/accordionQuery';
import seoQuery from '../modules/seo';
import newsListQuery from '../news/listQuery';

const ctas = `ctas[] {
  ...,
  "_key": _rev,
  'route': '/' + route->elements.slug.current,
}`;

export const query = `
  *[_type == "job" && slug.current == $slug] {
    "_key": _rev,
    _updatedAt,
    _createdAt,
    title,
    type,
    location,
    redirectToExternalPage,
    externalUrl,
    theme,
    department->{
      "_key": _rev,
      "slug": slug.current,
      title,
    },
    "slug": slug.current,
    openGraphImage{
      ...,
      "url":asset->url,
    },
      
    seo {
      ${seoQuery}
    },
    content[] {
      ...,
      ${ctas},
      _type == 'linkToPageBanner' => {
        ...,
        links[] {
          ...,
          "slug": ref->elements.slug.current,
        }
      },
      _type == 'hero' => {
        ...,
      },
      _type == 'investorRelationsList' => {
        ${investorRelationsListQuery}
      },
      _type == 'jobList' => {
        ${careerListQuery}
      },
      _type == 'newsList' => {
        ${newsListQuery}
      },
      backgroundImage {
        ...,
        asset->
      },
      backgroundImages[] {
        ...,
        asset->
      },
      backgroundVideo {
        ...,
        asset->
      },
      backgroundVideoMobile {
        ...,
        asset->
      },
      _type == 'casesSelected' => {
        ...,
        cases[]-> {
          ...elements {
            ...,
            "imageUrl": mainImage.asset->url,
          }
        }
      },
      _type == 'accordion' => {
        ${accordionQuery}
      },
      _type == 'marquee' => {
        lead,
        logos[] {
          "imageUrl": asset->url,
        }
      },
      _type == 'downloadablesBanner' => {
        ...,
        "asset": file.asset->,
      },
      _type == 'ctaBanner' => {
        label,
        heading,
        lead,
        "ctaTitle": cta.title,
        "ctaInternal": cta.route->elements.slug.current,
        "ctaExternal": cta.link,
      },
      _type == 'twoColumnTextBanner' => {
        ...,
        rows[] {
          ...,
          rightColumn[] {
            ...,
            _type == 'cta' => {
              ...,
              "ctaInternal": route->elements.slug.current,
              "ctaExternal": link,
            },
          },
        },
      },
      _type == 'latestNews' => {
        "latestNews": *[_type=='news'] | order(dateTime(elements.publishedAt) desc) {
          ...elements {
            "uri": slug.current,
            title,
            description,
            publishedAt
          },
          _createdAt
        }[0..3],
      },
      _type == 'fullscreenImage' => {
        ...,
        "image": figure.asset->,
        "imageUrl": figure.asset->url,
      },
      _type == 'employeeCarousel' => {
        ...,
        "employees": *[_type=='employee'] {
          ...,
          "imageUrl": image.asset->url,
        }[],
      },
      _type == 'imageTextBanner' => {
        ...,
        image {
          ...,
          "url": asset->url
        },
      },
      _type == 'sectionHeader' => {
        ...,
      },
      _type == 'highlights' => {
        ...,
        list[] {
          ...,
          image {
            ...,
            "url": asset->url
          },
          link {
            ...,
            "route": route->elements.slug.current,
          }
        }
      },
      _type == 'imageBanner' => {
        ...,
        desktopImage {
          ...,
          "imageUrl": asset->url
        },
        tabletImage {
          ...,
          "imageUrl": asset->url
        },
        mobileImage {
          ...,
          "imageUrl": asset->url
        },
          ctas[] {
          ...,
          "ctaInternal": route->elements.slug.current,
          "ctaExternal": link,
        }
      }
    }
  }
[0]`;

export default module.exports = query.replace(/ +/g, '');